import React, { useEffect, useState } from 'react';
import {
  StyledBox,
  StyledButton,
  StyledCloseButton,
  StyledCloseButtonWrapper,
  StyledCloseIcon,
  StyledContainer,
  StyledContentWrapper,
  StyledModal,
  StyledSection,
  StyledTextPairing,
  StyledVideoContainer,
} from './ThankYouNoteSection.styles';
import { VimeoVideo } from '@components/VimeoVideo';
import { PlayIcon } from '@sections/rachel-zoe/HeroSection/HeroSection.styles';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import { useTranslation } from 'react-i18next';

const BANNER_ASSETS = {
  mobile: {
    thumbnail: 'registry-q12024/thank-you-notes/thank-you-note-mobile.avif',
    video: 'https://player.vimeo.com/video/880736719?muted=1&loop=1&autoplay=1&background=1',
    alt: 'wedding-registry-thank-you',
  },
  desktop: {
    thumbnail: 'registry-q12024/thank-you-notes/thank-you-note-image.avif',
    video: 'https://player.vimeo.com/video/880736731?muted=1&loop=1&autoplay=1&background=1',
    alt: 'wedding-registry-thank-you',
  },
};

const MODAL_ASSETS = {
  thumbnail: 'registry-q12024/thank-you-notes/thank-you-note-thumbnail.avif',
  video: 'https://player.vimeo.com/video/879551085?h=65b62d6ca1&muted=1&loop=1&autoplay=1&background=1',
};

export const ThankYouNoteSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoAssets, setVideoAssets] = useState(BANNER_ASSETS.mobile);

  const isMobile = useThemeMediaQuery('below_sm');

  useEffect(() => setVideoAssets(isMobile ? BANNER_ASSETS.mobile : BANNER_ASSETS.desktop), [isMobile]);

  const { t } = useTranslation('registry');
  const registryThankYouNoteSection = t('registryThankYouNoteSection');

  return (
    <StyledSection as="section" id="ThankYouNoteSection">
      <StyledContainer>
        <StyledBox>
          <VimeoVideo
            posterOptimization="default"
            posterUrl={videoAssets.thumbnail}
            embedUrl={videoAssets.video}
            alt={videoAssets.alt}
            title={registryThankYouNoteSection.bannerVideoTitle}
            autoPlay
            background
            controls={false}
            autoPause={false}
            muted
            loop
            cover
            aspectRatio={isMobile ? 9 / 16 : 3}
          />
        </StyledBox>
        <StyledContentWrapper>
          <StyledTextPairing
            title={registryThankYouNoteSection.title}
            titleColor="white"
            titleVariant="calloutHed40"
            body={registryThankYouNoteSection.body}
            bodyColor="white"
            bodyVariant="dek20"
          />
          <StyledButton
            id="watchThankYouVideo"
            variant="primeWeddingWebsites"
            onClick={() => {
              setIsModalOpen(true);
            }}
          >
            <PlayIcon size={16} name="play" color="mono1" />
            {registryThankYouNoteSection.button}
          </StyledButton>
        </StyledContentWrapper>
      </StyledContainer>
      <StyledModal
        isOpen={isModalOpen}
        style={{
          overlay: {
            background: 'rgba(0, 0, 0, 0.48)',
            backdropFilter: 'blur(6px)',
            zIndex: 101,
            overflow: 'hidden',
            overflowY: 'auto',
            display: 'flex',
            alignItems: 'center',
          },
          content: {
            display: 'flex',
            width: '100%',
            height: '100%',
            maxHeight: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
          },
        }}
      >
        <StyledVideoContainer>
          <StyledCloseButtonWrapper>
            <StyledCloseButton id="thank-you-note-modal-close" variant="altPurpleSecondary" onClick={() => setIsModalOpen(false)}>
              <StyledCloseIcon name="notAttending" color="mono1" />
            </StyledCloseButton>
          </StyledCloseButtonWrapper>
          <VimeoVideo
            posterOptimization="default"
            posterUrl={MODAL_ASSETS.thumbnail}
            embedUrl={MODAL_ASSETS.video}
            title={registryThankYouNoteSection.videoTitle}
            alt="wedding-registry-thankyou"
            autoPlay
            background
            controls={false}
            autoPause={false}
            muted
            loop
            cover
            aspectRatio={0.5}
          />
        </StyledVideoContainer>
      </StyledModal>
    </StyledSection>
  );
};
